export default __webpack_public_path__ + "images/aa83b3e78cec81f917e3c97df316585d.svg";